import type { Bulletin } from '@shared/types/Bulletin';
import type { Salarie } from '@shared/types/Salarie';

/** Données FICTIVES pour l'aperçu de la charte (jamais d'information réelle de l'entreprise ou d'un salarié). */
export const APERCU_SALARIE: Salarie = {
  id: 'apercu-salarie',
  tenant_id: 'apercu',
  matricule: 'M0001',
  nom: 'EXEMPLE',
  prenom: 'Marie',
  date_naissance: '1990-05-14',
  nationalite: 'Gabonaise',
  poste: 'Assistante de direction',
  categorie: 'Employe qualifie',
  statut_contrat: 'CDI',
  statut: 'actif',
  date_embauche: '2021-03-01',
  salaire_base: 450_000,
  situation: 'celibataire',
  enfants: 0,
  cree_le: '2021-03-01T00:00:00.000Z',
};

export const APERCU_BULLETIN: Bulletin = {
  id: 'apercu-bulletin',
  tenant_id: 'apercu',
  salarie_id: 'apercu-salarie',
  periode: '2026-09',
  date_emission: '2026-09-30',
  brut_base: 450_000,
  brut_total: 450_000,
  brut_imposable: 450_000,
  base_cnss: 450_000,
  base_cnamgs: 450_000,
  cnss_pf_emp: 36_000,
  cnss_rp_emp: 9_000,
  cnss_vid_emp: 15_750,
  cnss_vid_sal: 9_000,
  cnamgs_emp: 18_450,
  cnamgs_fam_emp: 0,
  cnamgs_sal: 9_000,
  cfp_emp: 0,
  fnh_emp: 0,
  tcs: 0,
  css: 0,
  total_charges_emp: 79_200,
  cout_employeur: 529_200,
  parts: 1,
  abattement: 0,
  net_imposable: 432_000,
  irpp_mensuel: 12_000,
  net_a_payer: 420_000,
  jours_travailles: 30,
  statut: 'valide',
};
